import Guid from '@/services/Guid';
import { CloseOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { message } from 'antd';
import styles from './styles.less';
interface IProps {
    content: any;
    type?: 'warning' | 'error' | 'info';
    instanceKey?: string;
    duration?: number;
}

const messageToaster = ({ content, instanceKey = Guid.create(), duration = 10, type = 'error' }: IProps) => {
    if (!content) return;

    return message.open({
        content: (
            <div className={styles.errorContainer}>
                <CloseOutlined onClick={() => message.destroy(instanceKey)} className={styles.closeIcon} />
                {content}
            </div>
        ),
        key: instanceKey,
        duration,
        icon: (
            <ExclamationCircleFilled
                style={{
                    color: type === 'info' ? '#005CA9' : type === 'warning' ? '#FAAD14' : 'red',
                    fontSize: 24,
                }}
            />
        ),
        style: {
            // Ignore the height of the <NoticeBar />
            marginTop: '30px',
        },
    });
};

export default messageToaster;
